import { render, staticRenderFns } from "./chatIndex.vue?vue&type=template&id=0768d49e&scoped=true&"
import script from "./chatIndex.vue?vue&type=script&lang=js&"
export * from "./chatIndex.vue?vue&type=script&lang=js&"
import style0 from "./chatIndex.vue?vue&type=style&index=0&id=0768d49e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0768d49e",
  null
  
)

export default component.exports